(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 3303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.847 2.179a.52.52 0 0 1 0 .739L4.543 10.22a.52.52 0 0 1-.738 0L.153 6.569a.522.522 0 1 1 .739-.738l3.282 3.283 6.934-6.935a.52.52 0 0 1 .739 0"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgCheck);

/***/ }),

/***/ 33064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgDailyTraffic = function SvgDailyTraffic(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#FF6D5E",
    d: "M30.55 11.385H9.671l3.82 3.82-.567.564-4.384-4.384h-.234v-.234l-.166-.166.166-.165v-.235h.235l4.383-4.383.566.565-3.819 3.818H30.55z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#0D5284",
    d: "M16 .133C24.763.133 31.867 7.237 31.867 16S24.763 31.867 16 31.867.133 24.763.133 16 7.237.133 16 .133M1.934 21.411C4.108 27.06 9.586 31.067 16 31.067c8.321 0 15.067-6.746 15.067-15.067S24.32.933 16 .933.933 7.68.933 16c0 1.608.252 3.158.72 4.611h20.502l-3.818-3.818.565-.566 4.385 4.384h.233v.234l.166.166-.165.166v.234h-.235l-4.384 4.384-.565-.566 3.818-3.818Z"
  }))));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgDailyTraffic);

/***/ }),

/***/ 40480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgGlobalNetwork = function SvgGlobalNetwork(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#0D5284",
    d: "M16 3.333q.644 0 1.31.063l.335.035-.091.795a13.41 13.41 0 0 0-10.02 2.902l.846 1.271.051.018q.143.05.284.109l.138.061c.332.157.573.326.7.556.212.38.271.837.213 1.347a5 5 0 0 1-.33 1.251 7 7 0 0 1-.157.367l-.108.225-.04.074-.012.158a9 9 0 0 1-.064.543 3 3 0 0 1-.159.664c-.059.148-.166.28-.314.416a3.6 3.6 0 0 1-.47.351 7 7 0 0 1-.473.278l-.108.057-.104.182q-.185.332-.358.698-.19.407-.318.774c-.12.35-.183.65-.183.878 0 .754.47 1.207 1.186 1.283a2.76 2.76 0 0 1 1.399.701c.2.182.354.364.466.523l.046.068.137.044c.217.072.436.156.642.251.466.216.808.458.984.766.185.324.173.81.045 1.478a10 10 0 0 1-.142.622 13 13 0 0 1-.104.375l-.092.298.018.098.012.074c.052.332.07.674.037 1.002q-.03.289-.117.539c-.108.306-.3.595-.55.868a4 4 0 0 1-.476.443l-.032.024-.076.169-.072.152a9 9 0 0 1-.517.93q-.307.482-.636.824a13.4 13.4 0 0 0 5.7 2.038l-.065-.137-.085-.19c-.21-.488-.29-.843-.176-1.157.116-.319.438-.55.93-.782q.174-.082.358-.154l.096-.037-.013-.089a4 4 0 0 1-.03-.507l.007-.167c.033-.474.18-.864.496-1.116.3-.241.66-.306 1.077-.251.13.016.251.042.406.081l.463.121.02-.092c.036-.188.06-.45.074-.761.012-.261.016-.536.014-.802l-.007-.407-.005-.162.141-.156.09-.093.122-.119c.189-.18.397-.36.62-.53.536-.406 1.074-.685 1.601-.776l.072-.012c.366-.051.762.047 1.186.26.341.17.695.412 1.055.708.247.204.484.42.702.638l.196.2.339.084.279.071c.553.145 1.106.305 1.623.476q.51.166.93.336a13.4 13.4 0 0 0 2.525-7.854q0-1.185-.202-2.336l-.062-.328.785-.157c.185.923.279 1.867.279 2.821 0 7.88-6.388 14.267-14.267 14.267-7.88 0-14.267-6.388-14.267-14.267C1.733 9.72 8.121 3.333 16 3.333m4.743 20.14-.046.008c-.379.066-.811.29-1.255.626q-.223.169-.42.35l-.186.174-.042.042.004.259q.002.28-.005.563l-.01.279-.012.25-.016.225c-.057.678-.175 1.008-.518 1.122a.84.84 0 0 1-.395.024l-.177-.033-.412-.11-.15-.037-.126-.024-.06-.009c-.22-.029-.368-.002-.473.082-.108.086-.179.274-.198.548-.014.205.003.433.04.658l.027.151.015.062.094.368-.427.134-.149.053a6 6 0 0 0-.475.196c-.3.14-.503.287-.519.33a.3.3 0 0 0 .007.119l.024.1.04.124.054.145.034.08.076.17.225.465.04.084q.321.016.648.016a13.44 13.44 0 0 0 10.434-4.952 15 15 0 0 0-.672-.237 26 26 0 0 0-1.173-.353l-.542-.145-.576-.142-.124-.028-.143-.158-.194-.198c-.2-.2-.419-.4-.645-.587a5 5 0 0 0-.905-.611c-.293-.147-.538-.208-.717-.182M2.533 17.6c0 4.466 2.174 8.424 5.522 10.874a4 4 0 0 0 .633-.792c.172-.268.33-.557.47-.847l.108-.228.066-.152.045-.11.115-.08.086-.067.038-.03c.112-.094.225-.2.33-.313.183-.2.318-.403.385-.594a1.6 1.6 0 0 0 .075-.354c.026-.25.01-.528-.031-.798l-.036-.193-.034-.141.087-.261.017-.056q.075-.246.148-.518a9 9 0 0 0 .13-.57l.035-.197.024-.18.015-.16.006-.138c.002-.126-.01-.215-.033-.256-.071-.124-.3-.285-.627-.437a5 5 0 0 0-.557-.218l-.174-.055-.075-.02-.168-.045-.092-.171-.036-.056-.055-.08a2.5 2.5 0 0 0-.336-.375 1.96 1.96 0 0 0-.97-.5c-1.076-.114-1.876-.886-1.876-2.076 0-.33.08-.711.226-1.137q.143-.412.351-.855c.122-.26.253-.512.383-.747l.105-.184.073-.122.06-.1.162-.079.13-.07c.145-.077.288-.16.42-.246.15-.096.276-.188.366-.27q.04-.036.065-.065l.037-.044.007-.012q.025-.063.05-.163l.031-.149.03-.175q.024-.157.042-.326l.032-.362.007-.123.091-.165.046-.09a6 6 0 0 0 .208-.473c.144-.365.244-.723.28-1.05.042-.358.003-.652-.116-.867-.022-.04-.152-.131-.342-.22a3 3 0 0 0-.226-.096l-.168-.06-.103-.033-.141-.04-.953-1.43A13.43 13.43 0 0 0 2.533 17.6"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#FF6D5E",
    d: "M23.367.133c3.614 0 6.728 2.744 6.728 6.587 0 2.785-2.24 6.08-5.412 9.275l-.309.307-.26.251-.239.227-.185.17-.323.288-.266-.236-.177-.162-.304-.287-.26-.252-.309-.307C18.881 12.8 16.64 9.505 16.64 6.72c0-3.843 3.113-6.587 6.727-6.587m0 .8c-3.193 0-5.927 2.41-5.927 5.787 0 1.934 1.298 4.276 3.289 6.65l.32.375q.325.375.673.75l.351.374q.267.28.545.56l.17.17.261.257.318.303.195-.184.252-.244.302-.3a37 37 0 0 0 .722-.748l.346-.375c2.449-2.688 4.11-5.4 4.11-7.588 0-3.377-2.733-5.787-5.927-5.787m0 3.419a2.51 2.51 0 1 1 0 5.018 2.51 2.51 0 0 1 0-5.018m0 .8a1.71 1.71 0 1 0 0 3.418 1.71 1.71 0 0 0 0-3.418"
  }))));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgGlobalNetwork);

/***/ }),

/***/ 86515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgVideos = function SvgVideos(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#0D5284",
    d: "M28.908 7.197c1.707 0 3.092 1.397 3.092 3.121v18.56C32 30.603 30.615 32 28.908 32H3.092C1.385 32 0 30.602 0 28.879v-18.56c0-1.725 1.385-3.122 3.092-3.122Zm0 .814H3.092a2.296 2.296 0 0 0-2.285 2.307v18.56a2.296 2.296 0 0 0 2.285 2.308h25.816a2.296 2.296 0 0 0 2.285-2.307v-18.56a2.296 2.296 0 0 0-2.285-2.308M28.1 3.598v1.01H3.899v-1.01h24.202ZM24.759 0v1.01H7.24V0h17.52Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#FF6D5E",
    d: "M13.369 14.011v11.174l7.783-5.587zm.806 1.579 5.585 4.008-5.585 4.009z"
  }))));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgVideos);

/***/ }),

/***/ 62890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/reduced-motion/use-reduced-motion.mjs
var use_reduced_motion = __webpack_require__(23302);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 5 modules
var AnimatePresence = __webpack_require__(51526);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 75 modules
var motion = __webpack_require__(38439);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-in-view.mjs + 1 modules
var use_in_view = __webpack_require__(16893);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/use-scroll.mjs + 11 modules
var use_scroll = __webpack_require__(79645);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/use-transform.mjs + 3 modules
var use_transform = __webpack_require__(48828);
// EXTERNAL MODULE: ./src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(21548);
// EXTERNAL MODULE: ./src/components/Image/Image.tsx
var Image = __webpack_require__(41289);
// EXTERNAL MODULE: ./src/components/List/List.tsx + 1 modules
var List = __webpack_require__(15535);
// EXTERNAL MODULE: ./src/components/Text/Text.tsx
var Text = __webpack_require__(40426);
// EXTERNAL MODULE: ./src/components/Pages/Home/CoreFeatures/CoreFeatureItem/CoreFeatureItem.module.scss
var CoreFeatureItem_module = __webpack_require__(80363);
var CoreFeatureItem_module_default = /*#__PURE__*/__webpack_require__.n(CoreFeatureItem_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Pages/Home/CoreFeatures/CoreFeatureItem/CoreFeatureItem.tsx









var CoreFeatureItem = function CoreFeatureItem(_ref) {
  var title = _ref.title,
      text = _ref.text,
      list = _ref.list,
      button = _ref.button,
      image = _ref.image,
      visibleItem = _ref.visibleItem,
      onVisible = _ref.onVisible;
  var ref = react.useRef(null);
  var shouldReduceMotion = (0,use_reduced_motion/* useReducedMotion */.J)();
  var isInView = (0,use_in_view/* useInView */.Y)(ref, {
    amount: 'all',
    once: false
  });

  var _useScroll = (0,use_scroll/* useScroll */.v)({
    target: ref,
    axis: 'y',
    offset: ['start start', 'start end'] // offset: scrollDirection === 'down' ? ['start end', 'end end'] : ['end start', 'end end'],

  }),
      scrollYProgress = _useScroll.scrollYProgress;

  var value = (0,use_transform/* useTransform */.H)(scrollYProgress, [0, 0.5, 1], [0.2, 1, 0.2]);
  react.useEffect(function () {
    if (isInView) {
      onVisible();
    }
  }, [isInView]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
    className: (CoreFeatureItem_module_default()).wrapper,
    style: shouldReduceMotion ? undefined : {
      opacity: visibleItem === title ? 1 : value
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (CoreFeatureItem_module_default()).content,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        ref: ref,
        className: (CoreFeatureItem_module_default()).refWrapper
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
        className: "mb-5",
        color: "gray900",
        size: 30,
        tag: "h2",
        weight: "bold",
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
        className: "mb-5",
        size: 18,
        tag: "p",
        children: text
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(List/* List */.a, {
        gap: 15,
        items: list,
        size: 18,
        ulClassName: button !== undefined ? 'mb-6' : undefined
      }), button && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* Button */.z, {
        href: button.href,
        theme: "button",
        variant: "secondary",
        children: button.text
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, {
      alt: "",
      className: (CoreFeatureItem_module_default()).image,
      height: image.height,
      src: image.src,
      width: image.width
    })]
  });
};
// EXTERNAL MODULE: ./src/components/Section/Section.tsx
var Section = __webpack_require__(34049);
// EXTERNAL MODULE: ./src/hooks/useIsMounted.ts
var useIsMounted = __webpack_require__(31686);
// EXTERNAL MODULE: ./src/routes.ts
var routes = __webpack_require__(20925);
// EXTERNAL MODULE: ./src/components/Pages/Home/CoreFeatures/CoreFeatures.module.scss
var CoreFeatures_module = __webpack_require__(91412);
var CoreFeatures_module_default = /*#__PURE__*/__webpack_require__.n(CoreFeatures_module);
// EXTERNAL MODULE: ./src/components/Pages/Home/CoreFeatures/client-centric.png
var client_centric = __webpack_require__(75889);
var client_centric_default = /*#__PURE__*/__webpack_require__.n(client_centric);
// EXTERNAL MODULE: ./src/components/Pages/Home/CoreFeatures/stability.png
var stability = __webpack_require__(9298);
var stability_default = /*#__PURE__*/__webpack_require__.n(stability);
// EXTERNAL MODULE: ./src/components/Pages/Home/CoreFeatures/video-delivery.png
var video_delivery = __webpack_require__(89948);
var video_delivery_default = /*#__PURE__*/__webpack_require__.n(video_delivery);
;// CONCATENATED MODULE: ./src/components/Pages/Home/CoreFeatures/CoreFeatures.tsx














var data = [{
  title: 'Client-centric at every step',
  text: 'From custom onboarding to detailed optimizations and continuous monitoring, we go above and beyond to meet and exceed your expectations.',
  list: ['Direct access to L2/L3 engineers through your preferred dedicated communication channel for fast, expert support.', 'Client-specific customizations are included as part of our standard service.'],
  image: {
    src: (client_centric_default()),
    width: 475,
    height: 552
  }
}, {
  title: 'Video delivery at our core',
  text: 'With 90% of our delivered data dedicated to video, high-quality streaming is where we thrive.',
  list: ['Tailored caching strategies optimized for both live and on-demand delivery.', 'Scalable infrastructure ready to serve massive global audiences.', 'Deep expertise in low-latency live streaming.'],
  button: {
    text: 'Video delivery',
    href: routes/* routes.videoCdn */._j.videoCdn
  },
  image: {
    src: (video_delivery_default()),
    width: 475,
    height: 633
  }
}, {
  title: 'Stability through cost efficiency',
  text: 'We prioritize cost efficiency for our business and clients – building lasting, sustainable partnerships.',
  list: ['Over a decade of profitability and steady growth.', 'Reached annual revenue of $175M in 2024.', 'Ranked among the top 5 largest CDNs by revenue.'],
  button: {
    text: 'About us',
    href: routes/* routes.aboutUs */._j.aboutUs
  },
  image: {
    src: (stability_default()),
    width: 475,
    height: 566
  }
}];
var CoreFeatures = function CoreFeatures() {
  var wrapperRef = react.useRef(null);
  var shouldReduceMotion = (0,use_reduced_motion/* useReducedMotion */.J)();
  var isMounted = (0,useIsMounted/* useIsMounted */.t)();

  var _React$useState = react.useState(data[0].title),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      visibleItem = _React$useState2[0],
      setVisibleItem = _React$useState2[1];

  var withAnimation = isMounted && !shouldReduceMotion;
  var activeItem = data.find(function (_ref) {
    var title = _ref.title;
    return title === visibleItem;
  });
  react.useEffect(function () {
    var _document$documentEle, _document$documentEle2, _wrapperRef$current, _element$top, _element$height;

    var documentScroll = (_document$documentEle = (_document$documentEle2 = document.documentElement) === null || _document$documentEle2 === void 0 ? void 0 : _document$documentEle2.scrollTop) !== null && _document$documentEle !== void 0 ? _document$documentEle : 0;
    var element = (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.getBoundingClientRect();
    var wrapperScroll = (_element$top = element === null || element === void 0 ? void 0 : element.top) !== null && _element$top !== void 0 ? _element$top : 0; // top relative to viewport

    var wrapperHeight = (_element$height = element === null || element === void 0 ? void 0 : element.height) !== null && _element$height !== void 0 ? _element$height : 0;
    var startOfLastItem = documentScroll + wrapperScroll + wrapperHeight * 0.66;

    if (documentScroll > startOfLastItem) {
      setVisibleItem(data[data.length - 1].title);
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Section/* Section */.$, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      ref: wrapperRef,
      className: (CoreFeatures_module_default()).wrapper,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (CoreFeatures_module_default()).content,
        children: data.map(function (_ref2) {
          var title = _ref2.title,
              text = _ref2.text,
              list = _ref2.list,
              button = _ref2.button,
              image = _ref2.image;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(CoreFeatureItem, {
            button: button,
            image: image,
            list: list,
            text: text,
            title: title,
            visibleItem: visibleItem,
            onVisible: function onVisible() {
              setVisibleItem(title);
            }
          }, title);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (CoreFeatures_module_default()).sticky,
        style: {
          color: 'white'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
          mode: "popLayout",
          children: activeItem && /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
            animate: withAnimation ? {
              opacity: 1
            } : undefined,
            exit: withAnimation ? {
              opacity: 0
            } : undefined,
            initial: withAnimation ? {
              opacity: activeItem.title === data[0].title ? 1 : 0
            } : undefined,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, {
              alt: "",
              height: activeItem.image.height,
              src: activeItem.image.src,
              width: activeItem.image.width
            })
          }, activeItem.image.height)
        })
      })]
    })
  });
};
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./src/components/Icon/Icon.tsx
var Icon = __webpack_require__(37078);
// EXTERNAL MODULE: ./src/components/Tiles/Tiles.module.scss
var Tiles_module = __webpack_require__(35278);
var Tiles_module_default = /*#__PURE__*/__webpack_require__.n(Tiles_module);
;// CONCATENATED MODULE: ./src/components/Tiles/Tiles.tsx




var cx = bind_default().bind((Tiles_module_default()));
var Tiles = function Tiles(_ref) {
  var higherContrast = _ref.higherContrast,
      _ref$tabletVariant = _ref.tabletVariant,
      tabletVariant = _ref$tabletVariant === void 0 ? '3-columns' : _ref$tabletVariant,
      className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
    className: cx('wrapper', className, "layout-".concat(tabletVariant), {
      higherContrast: higherContrast
    }),
    children: children.map(function (item, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: (Tiles_module_default()).item,
        children: item
      }, index);
    })
  });
};
// EXTERNAL MODULE: ./src/siteData.ts
var siteData = __webpack_require__(97992);
// EXTERNAL MODULE: ./src/components/Pages/Home/HomeHeader/HomeTiles/HomeTiles.module.scss
var HomeTiles_module = __webpack_require__(7378);
var HomeTiles_module_default = /*#__PURE__*/__webpack_require__.n(HomeTiles_module);
// EXTERNAL MODULE: ./src/components/Images/Icons/dailyTraffic.svg
var dailyTraffic = __webpack_require__(33064);
;// CONCATENATED MODULE: ./src/components/Images/Icons/engineering.svg
var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgEngineering = function SvgEngineering(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "#FF6D5E",
    d: "M31.867 10.679v.8h-4.219v6.796l-5.395 5.396a2.51 2.51 0 1 1-.566-.566l5.161-5.162V10.68zM20.218 23.43a1.71 1.71 0 1 0 0 3.418 1.71 1.71 0 0 0 0-3.418M11.782 4.352a2.51 2.51 0 1 1-1.47 4.543l-5.16 5.161v7.265H.133v-.8h4.218v-6.796L9.749 8.33a2.51 2.51 0 0 1 2.034-3.978m0 .8a1.71 1.71 0 1 0 0 3.418 1.71 1.71 0 0 0 0-3.418"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#0D5284",
    d: "M31.867 14.897v8.299l-8.671 8.67h-6.19v-.8h5.859l8.202-8.202v-7.967zM9.37 15.6v5.155l4.218 4.219v6.893H8.804L6.22 29.283a2.51 2.51 0 1 1 .566-.566l2.35 2.35h3.652v-5.762L8.57 21.087V15.6zm-4.618 9.94a1.71 1.71 0 1 0 0 3.418 1.71 1.71 0 0 0 0-3.419M16 13.49a2.51 2.51 0 1 1 0 5.02 2.51 2.51 0 0 1 0-5.02m0 .8a1.71 1.71 0 1 0 0 3.42 1.71 1.71 0 0 0 0-3.42M14.994.134v.8h-5.86l-8.2 8.202v7.968h-.8V8.804l8.67-8.67zm8.202 0 2.583 2.584a2.51 2.51 0 1 1-.565.565L22.864.933h-3.652v5.764L23.43 11v5.4h-.8v-5.074l-4.218-4.302V.134zm4.052 2.91a1.71 1.71 0 1 0 0 3.418 1.71 1.71 0 0 0 0-3.419"
  })));
};
/* harmony default export */ var engineering = (SvgEngineering);
// EXTERNAL MODULE: ./src/components/Images/Icons/videos.svg
var videos = __webpack_require__(86515);
;// CONCATENATED MODULE: ./src/components/Pages/Home/HomeHeader/HomeTiles/HomeTiles.tsx












var items = [{
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(engineering, {}),
  value: "".concat(siteData/* cdnStats.yearsOnMarket */.MZ.yearsOnMarket, " years"),
  title: 'of expertise in CDN',
  text: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: "Year after year, we remain financially stable with double-digit growth, while delivering satisfaction to thousands of\xA0clients."
  })
}, {
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(dailyTraffic/* default */.Z, {}),
  value: siteData/* cdnStats.capacity.network */.MZ.capacity.network,
  title: 'global network capacity',
  text: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: "Our regional network quality is consistently rated as exceptional compared to other leading CDN\xA0providers."
  })
}, {
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(videos/* default */.Z, {}),
  value: siteData/* cdnStats.dailyTraffic.video */.MZ.dailyTraffic.video,
  title: 'of video delivered daily',
  text: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: "Built with large media companies in mind, our CDN delivers live and VOD content on a massive\xA0scale."
  })
}];
var HomeTiles = function HomeTiles() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Tiles, {
    tabletVariant: "2-columns",
    higherContrast: true,
    children: items.map(function (_ref) {
      var icon = _ref.icon,
          value = _ref.value,
          title = _ref.title,
          text = _ref.text;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (HomeTiles_module_default()).item,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* Icon */.J, {
          className: (HomeTiles_module_default()).icon,
          size: 30,
          children: icon
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
          className: "mb-2",
          color: "blue700",
          display: "block",
          size: 32,
          tag: "strong",
          children: value
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
          className: "mb-6",
          color: "gray500",
          size: 16,
          tag: "p",
          children: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
          size: 16,
          tag: "p",
          children: text
        })]
      }, title);
    })
  });
};
// EXTERNAL MODULE: ./src/components/Layout/Container/Container.tsx
var Container = __webpack_require__(59339);
// EXTERNAL MODULE: ./src/components/LogosRow/LogosRow.tsx
var LogosRow = __webpack_require__(91546);
// EXTERNAL MODULE: ./src/components/Padding/Padding.tsx + 1 modules
var Padding = __webpack_require__(77838);
// EXTERNAL MODULE: ./src/components/Pages/Home/HomeHeader/HomeHeader.module.scss
var HomeHeader_module = __webpack_require__(27586);
var HomeHeader_module_default = /*#__PURE__*/__webpack_require__.n(HomeHeader_module);
// EXTERNAL MODULE: ./src/components/Pages/Home/HomeHeader/globe.png
var globe = __webpack_require__(56129);
var globe_default = /*#__PURE__*/__webpack_require__.n(globe);
;// CONCATENATED MODULE: ./src/components/Pages/Home/HomeHeader/HomeHeader.tsx














var HomeHeader_cx = bind_default().bind((HomeHeader_module_default()));
var HomeHeader = function HomeHeader() {
  var ref = react.useRef(null);
  var shouldReduceMotion = (0,use_reduced_motion/* useReducedMotion */.J)();
  var isMounted = (0,useIsMounted/* useIsMounted */.t)();

  var _useScroll = (0,use_scroll/* useScroll */.v)({
    target: ref
  }),
      scrollY = _useScroll.scrollY;

  var y = (0,use_transform/* useTransform */.H)(scrollY, [0, 1000], [0, 250]);
  var opacity = (0,use_transform/* useTransform */.H)(scrollY, [0, 1000], [1, 0]);
  var withAnimation = isMounted && !shouldReduceMotion;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
    ref: ref,
    className: (HomeHeader_module_default()).wrapper,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* Container */.W, {
      className: (HomeHeader_module_default()).container,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Padding/* Padding */.Z, {
        size: {
          top: 170,
          bottom: 60,
          x: 0
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: HomeHeader_cx('titleWrapper', 'mb-8'),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
            className: "mb-2",
            color: "gray900",
            display: "block",
            size: 56,
            tag: "h1",
            weight: "bold",
            children: "Big enough to handle your traffic."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
            color: "gray500",
            display: "block",
            opacity: 70,
            size: 34,
            tag: "p",
            children: "Never big enough to stop putting clients first."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mb-8",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(HomeTiles, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LogosRow/* LogosRow */.H, {
          note: "Trusted by"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (HomeHeader_module_default()).globe,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
            style: withAnimation ? {
              y: y,
              opacity: opacity
            } : undefined,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, {
              alt: "",
              height: 985,
              src: (globe_default()),
              width: 993,
              priority: true
            })
          })
        })]
      })
    })
  });
};
// EXTERNAL MODULE: ./src/components/ReviewsCarousel/ReviewsCarousel.tsx + 1 modules
var ReviewsCarousel = __webpack_require__(23514);
;// CONCATENATED MODULE: ./src/components/Pages/Home/HomeReviews/HomeReviews.tsx






var HomeReviews = function HomeReviews() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Section/* Section */.$, {
    overflow: "hidden",
    padding: {
      top: 150,
      bottom: 150
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
      align: "center",
      className: "mb-1",
      color: "blue300",
      display: "block",
      size: 14,
      tag: "strong",
      transform: "uppercase",
      weight: "medium",
      children: "Enough from us."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
      align: "center",
      className: "mb-7",
      color: "gray900",
      display: "block",
      size: 44,
      tag: "h2",
      weight: "regular",
      children: "What others say about CDN77?"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ReviewsCarousel/* ReviewsCarousel */.i, {})]
  });
};
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/animation/animate.mjs + 12 modules
var animate = __webpack_require__(24213);
;// CONCATENATED MODULE: ./src/components/Counter/Counter.tsx





var Counter = function Counter(_ref) {
  var from = _ref.from,
      to = _ref.to,
      delay = _ref.delay;
  var shouldReduceMotion = (0,use_reduced_motion/* useReducedMotion */.J)();
  var isMounted = (0,useIsMounted/* useIsMounted */.t)();
  var ref = react.useRef(null);
  var isInView = (0,use_in_view/* useInView */.Y)(ref, {
    once: true
  });
  react.useEffect(function () {
    if (!isInView || shouldReduceMotion || !isMounted) return;
    var node = ref.current;
    if (!node) return;
    var controls = (0,animate/* animate */.j)(from, to, {
      duration: 1,
      delay: delay,
      onUpdate: function onUpdate(value) {
        node.textContent = Math.round(value).toString();
      }
    });
    return function () {
      return controls.stop();
    };
  }, [from, to, isInView, shouldReduceMotion, isMounted]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.span */.E.span, {
    ref: ref,
    children: !isMounted || shouldReduceMotion ? to : undefined
  });
};

/* harmony default export */ var Counter_Counter = (Counter);
// EXTERNAL MODULE: ./src/components/Pages/Home/NetworkStats/ContinentStats/ContinentStats.module.scss
var ContinentStats_module = __webpack_require__(57865);
var ContinentStats_module_default = /*#__PURE__*/__webpack_require__.n(ContinentStats_module);
// EXTERNAL MODULE: ./src/components/Pages/Home/NetworkStats/ContinentStats/map.png
var map = __webpack_require__(66313);
var map_default = /*#__PURE__*/__webpack_require__.n(map);
;// CONCATENATED MODULE: ./src/components/Pages/Home/NetworkStats/ContinentStats/ContinentStats.tsx








var ContinentStats_data = [{
  value: 29,
  title: 'North America',
  left: 14,
  top: 30
}, {
  value: 31,
  title: 'Europe',
  left: 48.5,
  top: 23.5
}, {
  value: 21,
  title: 'Asia & Pacific',
  left: 70.5,
  top: 45
}, {
  value: 13,
  title: 'South America',
  left: 24,
  top: 67
}, {
  value: 6,
  title: 'Africa',
  left: 48.5,
  top: 53
}];
var ContinentStats = function ContinentStats() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (ContinentStats_module_default()).wrapper,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: (ContinentStats_module_default()).stats,
      children: ContinentStats_data.map(function (_ref) {
        var value = _ref.value,
            title = _ref.title,
            left = _ref.left,
            top = _ref.top;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: (ContinentStats_module_default()).item,
          style: {
            left: "".concat(left, "%"),
            top: "".concat(top, "%")
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* Text */.x, {
            className: (ContinentStats_module_default()).value,
            color: "blue300",
            display: "block",
            size: 56,
            tag: "p",
            weight: "bold",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Counter_Counter, {
              delay: 0.2,
              from: 0,
              to: value
            }), "%"]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
            className: (ContinentStats_module_default()).name,
            color: "gray500",
            size: 16,
            tag: "p",
            children: title
          })]
        }, title);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, {
      alt: "",
      height: 820,
      src: (map_default()),
      width: 1593
    })]
  });
};
// EXTERNAL MODULE: ./src/components/AnimatedPath/AnimatedPath.tsx
var AnimatedPath = __webpack_require__(7752);
// EXTERNAL MODULE: ./src/components/Pages/Home/NetworkStats/NetworkStats.module.scss
var NetworkStats_module = __webpack_require__(87870);
var NetworkStats_module_default = /*#__PURE__*/__webpack_require__.n(NetworkStats_module);
;// CONCATENATED MODULE: ./src/components/Images/Icons/cdns.svg
var cdns_path, cdns_path2;
function cdns_extends() { return cdns_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, cdns_extends.apply(null, arguments); }

var SvgCdns = function SvgCdns(props) {
  return /*#__PURE__*/react.createElement("svg", cdns_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), cdns_path || (cdns_path = /*#__PURE__*/react.createElement("path", {
    fill: "#FF6D5E",
    d: "m23.745 14.47.554.577-9.8 9.414-.554-.577zm4.15-1.77.79.116-1.69 11.534-.79-.116zm-2.072-2.104.174.78-19.82 4.404-.173-.78zM8.66 6.762l.678.425-4.372 6.982-.678-.425zm4.879-3.84 9.931 4.676-.34.724-9.932-4.677z"
  })), cdns_path2 || (cdns_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#0D5284",
    d: "M25.842 26.848a2.51 2.51 0 1 1 0 5.019 2.51 2.51 0 0 1 0-5.019m0 .8a1.71 1.71 0 1 0 0 3.419 1.71 1.71 0 0 0 0-3.419M12.485 22.63a3.212 3.212 0 1 1 0 6.425 3.212 3.212 0 0 1 0-6.425m0 .8a2.412 2.412 0 1 0 0 4.825 2.412 2.412 0 0 0 0-4.825m-9.14-10.642a3.212 3.212 0 1 1 0 6.424 3.212 3.212 0 0 1 0-6.424m0 .8a2.412 2.412 0 1 0 0 4.824 2.412 2.412 0 0 0 0-4.824m25.31-6.424a3.212 3.212 0 1 1 0 6.424 3.212 3.212 0 0 1 0-6.424m0 .8a2.412 2.412 0 1 0 0 4.824 2.412 2.412 0 0 0 0-4.824M11.782.134a2.51 2.51 0 1 1 0 5.018 2.51 2.51 0 0 1 0-5.019m0 .8a1.71 1.71 0 1 0 0 3.418 1.71 1.71 0 0 0 0-3.419"
  })));
};
/* harmony default export */ var cdns = (SvgCdns);
// EXTERNAL MODULE: ./src/components/Images/Icons/globalNetwork.svg
var globalNetwork = __webpack_require__(40480);
// EXTERNAL MODULE: ./src/components/Images/Icons/peak.svg
var peak = __webpack_require__(37863);
;// CONCATENATED MODULE: ./src/components/Pages/Home/NetworkStats/NetworkStats.tsx
















var NetworkStats_data = [{
  value: siteData/* cdnStats.trafficPeak.total */.MZ.trafficPeak.total,
  title: 'daily traffic peaks',
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(peak/* default */.Z, {})
}, {
  value: "".concat(siteData/* cdnStats.ispConnected.toString */.MZ.ispConnected.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' '), "+"),
  title: 'ISPs connected directly',
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(cdns, {})
}, {
  value: "".concat(siteData/* cdnStats.locationsCount.fullPops */.MZ.locationsCount.fullPops + siteData/* cdnStats.locationsCount.onDemand */.MZ.locationsCount.onDemand, " PoPs"),
  title: 'across 6 continents',
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(globalNetwork/* default */.Z, {})
}];
var NetworkStats_cx = bind_default().bind((NetworkStats_module_default()));
var NetworkStats = function NetworkStats() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Section/* Section */.$, {
    className: (NetworkStats_module_default()).wrapper,
    padding: {
      top: 120,
      bottom: 20
    },
    theme: "tiles",
    withContainer: false,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Container/* Container */.W, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* Text */.x, {
        align: "center",
        className: "mb-5",
        color: "gray900",
        display: "block",
        maxWidth: 600,
        size: 44,
        tag: "h2",
        isCentered: true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("b", {
          children: "Deliver content"
        }), " to every corner of the Earth"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* Text */.x, {
        align: "center",
        className: "mb-8",
        color: "gray500",
        display: "block",
        maxWidth: 730,
        size: 18,
        tag: "p",
        isCentered: true,
        children: ["A network built with strategically placed ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Super PoPs"
        }), " and", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "ISP-embedded cache servers"
        }), ", ensuring broad coverage to", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "reach all eyeballs"
        }), ", even in hard-to-reach areas."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: NetworkStats_cx('tilesWrapper', 'mb-7'),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AnimatedPath/* AnimatedPath */.K, {
          align: "center",
          className: (NetworkStats_module_default()).path,
          delayMs: 200,
          durationMs: 500,
          height: 380
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Tiles, {
          className: (NetworkStats_module_default()).tiles,
          children: NetworkStats_data.map(function (_ref) {
            var icon = _ref.icon,
                title = _ref.title,
                value = _ref.value;
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (NetworkStats_module_default()).item,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                size: 50,
                children: icon
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (NetworkStats_module_default()).itemContent,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
                  className: (NetworkStats_module_default()).value,
                  color: "gray900",
                  display: "block",
                  size: 34,
                  tag: "strong",
                  weight: "medium",
                  children: value
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
                  className: (NetworkStats_module_default()).title,
                  color: "gray500",
                  size: 16,
                  tag: "p",
                  children: title
                })]
              })]
            }, title);
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
        align: "center",
        className: (NetworkStats_module_default()).mapTitle,
        color: "gray900",
        display: "block",
        size: 30,
        tag: "h3",
        weight: "bold",
        children: "Global traffic distribution"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContinentStats, {})]
    })
  });
};
// EXTERNAL MODULE: ./src/components/CtaPanel/CtaPanel.tsx
var CtaPanel = __webpack_require__(22316);
// EXTERNAL MODULE: ./src/components/Layout/Head.tsx
var Head = __webpack_require__(15934);
;// CONCATENATED MODULE: ./src/components/Pages/Home/Home.tsx












var Home = function Home(_ref) {
  var title = _ref.title;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      canonical: routes/* routes.homePage */._j.homePage,
      description: "Experience unmatched CDN performance at the best prices, powered by ".concat(siteData/* cdnStats.capacity.network */.MZ.capacity.network, " network across ").concat(siteData/* cdnStats.continentsCount */.MZ.continentsCount, " continents. Start testing with us today!"),
      title: title !== null && title !== void 0 ? title : 'Content Delivery Network (CDN)'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HomeHeader, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CoreFeatures, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(NetworkStats, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(HomeReviews, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CtaPanel/* CtaPanel */.a, {
      className: "mb-5"
    })]
  });
};
;// CONCATENATED MODULE: ./pages/index.ts

/* harmony default export */ var pages = (Home);

/***/ }),

/***/ 7752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ AnimatedPath; }
/* harmony export */ });
/* harmony import */ var _builds_purple_team_cdn77_frontend_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _AnimatedPath_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80607);
/* harmony import */ var _AnimatedPath_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_AnimatedPath_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);

var _excluded = ["delayMs", "durationMs", "align", "color", "className"];






var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_0___default().bind((_AnimatedPath_module_scss__WEBPACK_IMPORTED_MODULE_3___default()));
var AnimatedPath = function AnimatedPath(_ref) {
  var _ref$delayMs = _ref.delayMs,
      delayMs = _ref$delayMs === void 0 ? 500 : _ref$delayMs,
      _ref$durationMs = _ref.durationMs,
      durationMs = _ref$durationMs === void 0 ? 1000 : _ref$durationMs,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'none' : _ref$align,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'dark' : _ref$color,
      className = _ref.className,
      props = (0,_builds_purple_team_cdn77_frontend_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  var squareRef = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
  var pathWrapperRef = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
  var isInView = (0,framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .useInView */ .Y)(pathWrapperRef, {
    amount: 'all'
  });
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function () {
    if (!isInView) return;
    var pathWrapper = pathWrapperRef === null || pathWrapperRef === void 0 ? void 0 : pathWrapperRef.current;

    if (pathWrapper) {
      var svg = pathWrapper.querySelector('svg');

      var _path = svg === null || svg === void 0 ? void 0 : svg.querySelector('path');

      if (svg && _path) {
        var pathPosition = _path.getBoundingClientRect();

        var pathTotalLength = 'path' in props ? _path.getTotalLength() : props.height;
        svg.style.strokeDasharray = pathTotalLength.toFixed(0);
        svg.style.strokeDashoffset = pathTotalLength.toFixed(0);
        svg.style.opacity = '1';

        var positionElements = function positionElements() {
          var pointPercentage = 'path' in props ? pathPosition.height : props.height;
          var pointOnPath = pointPercentage * pathTotalLength;

          var pathPoint = _path.getPointAtLength(pointOnPath);

          if (squareRef.current) {
            squareRef.current.style.transform = "translate(".concat(pathPoint.x, "px, ").concat('path' in props ? pathPoint.y : props.height, "px)");
          }
        };

        positionElements();
      }
    }
  }, [isInView]);
  var path = 'path' in props ? props.path : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", {
    height: props.height,
    viewBox: "0 0 1 ".concat(props.height),
    width: "1",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M.5 0v".concat(props.height)
    })
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: cx('wrapper', align, color, className),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: (_AnimatedPath_module_scss__WEBPACK_IMPORTED_MODULE_3___default().inner),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        ref: pathWrapperRef,
        children: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(path, {
          className: (_AnimatedPath_module_scss__WEBPACK_IMPORTED_MODULE_3___default().path),
          style: {
            animationDelay: "".concat(delayMs, "ms"),
            animationDuration: "".concat(durationMs, "ms")
          }
        })
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(path, {
        className: (_AnimatedPath_module_scss__WEBPACK_IMPORTED_MODULE_3___default().overlay)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        ref: squareRef,
        className: (_AnimatedPath_module_scss__WEBPACK_IMPORTED_MODULE_3___default().squareWrapper),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: (_AnimatedPath_module_scss__WEBPACK_IMPORTED_MODULE_3___default().square),
          style: {
            animationDelay: "".concat(delayMs + durationMs, "ms")
          }
        })
      })]
    })
  });
};

/***/ }),

/***/ 22316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ CtaPanel; }
/* harmony export */ });
/* harmony import */ var _builds_purple_team_cdn77_frontend_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _builds_purple_team_cdn77_frontend_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4730);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _CtaPanelWrapper_CtaPanelWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20813);
/* harmony import */ var _components_Button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21548);
/* harmony import */ var _components_Paragraph_Paragraph__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34687);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20925);
/* harmony import */ var _CtaPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61676);
/* harmony import */ var _CtaPanel_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_CtaPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);
'use client';



var _excluded = ["title"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_purple_team_cdn77_frontend_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_CtaPanel_module_scss__WEBPACK_IMPORTED_MODULE_8___default()));
var CtaPanel = function CtaPanel(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Deliver your content with CDN77' : _ref$title,
      text = _ref.text,
      _ref$buttons = _ref.buttons,
      buttons = _ref$buttons === void 0 ? [{
    title: 'Talk to sales',
    href: _routes__WEBPACK_IMPORTED_MODULE_6__/* .routes.getStarted */ ._j.getStarted,
    id: 'cta-contact'
  }] : _ref$buttons,
      children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_CtaPanelWrapper_CtaPanelWrapper__WEBPACK_IMPORTED_MODULE_3__/* .CtaPanelWrapper */ .U, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("h2", {
      className: cx('title', text ? 'mb-2' : 'mb-5'),
      children: title
    }), text && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_Paragraph_Paragraph__WEBPACK_IMPORTED_MODULE_5__/* .Paragraph */ .n, {
      align: "center",
      className: "mb-5",
      color: "light",
      opacity: 60,
      size: "lg",
      children: text
    }), children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
      className: (_CtaPanel_module_scss__WEBPACK_IMPORTED_MODULE_8___default().buttonsWrapper),
      children: buttons.map(function (_ref2, index) {
        var title = _ref2.title,
            rest = (0,_builds_purple_team_cdn77_frontend_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_ref2, _excluded);

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, _objectSpread(_objectSpread({
          className: (_CtaPanel_module_scss__WEBPACK_IMPORTED_MODULE_8___default().button),
          theme: "button",
          variant: index === 0 ? 'primary' : 'inverted'
        }, rest), {}, {
          children: title
        }), typeof title === 'string' ? "".concat(title, "-").concat(index) : index);
      })
    })]
  });
};

/***/ }),

/***/ 20813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ CtaPanelWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Image/Image.tsx
var Image = __webpack_require__(41289);
// EXTERNAL MODULE: ./src/components/Layout/Container/Container.tsx
var Container = __webpack_require__(59339);
// EXTERNAL MODULE: ./src/components/Section/Section.tsx
var Section = __webpack_require__(34049);
// EXTERNAL MODULE: ./src/components/CtaPanel/CtaPanelWrapper/CtaPanelWrapper.module.scss
var CtaPanelWrapper_module = __webpack_require__(19630);
var CtaPanelWrapper_module_default = /*#__PURE__*/__webpack_require__.n(CtaPanelWrapper_module);
// EXTERNAL MODULE: ./src/components/CtaPanel/CtaPanelWrapper/cta-globe.png
var cta_globe = __webpack_require__(39582);
var cta_globe_default = /*#__PURE__*/__webpack_require__.n(cta_globe);
;// CONCATENATED MODULE: ./src/components/CtaPanel/CtaPanelWrapper/cta-lines.svg
var cta_lines_namespaceObject = __webpack_require__.p + "static/media/cta-lines.d57745a7.svg";
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/CtaPanel/CtaPanelWrapper/CtaPanelWrapper.tsx
'use client';










var CtaPanelWrapper = function CtaPanelWrapper(_ref) {
  var _ref$background = _ref.background,
      background = _ref$background === void 0 ? 'globe' : _ref$background,
      className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Section/* Section */.$, {
    overflow: "hidden",
    padding: 0,
    withContainer: false,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* Container */.W, {
      className: className,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Section/* Section */.$, {
        borderRadius: "rounded",
        className: (CtaPanelWrapper_module_default()).section,
        padding: 90,
        isPulled: true,
        children: [background === 'globe' && /*#__PURE__*/(0,jsx_runtime.jsx)("figure", {
          className: (CtaPanelWrapper_module_default()).background,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, {
            alt: "",
            height: 569,
            src: (cta_globe_default()),
            width: 569
          })
        }), background === 'lines' && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          alt: "",
          className: (CtaPanelWrapper_module_default()).linesBackground,
          height: 855,
          src: cta_lines_namespaceObject,
          width: 1110
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (CtaPanelWrapper_module_default()).content,
          children: children
        })]
      })
    })
  });
};

/***/ }),

/***/ 15934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20925);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
var _process$env$NEXT_PUB;








var APP_URL = (_process$env$NEXT_PUB = "https://www.cdn77.com") !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : '';
var Head = function Head(_ref) {
  var description = _ref.description,
      title = _ref.title,
      noIndex = _ref.noIndex,
      canonical = _ref.canonical,
      ogUrl = _ref.ogUrl,
      imageOg = _ref.imageOg,
      imageTwitter = _ref.imageTwitter,
      children = _ref.children;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
      content: "width=device-width, initial-scale=1",
      name: "viewport"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("title", {
      children: "".concat(title, " | CDN77.com")
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
      content: ogUrl ? "".concat(APP_URL.replace(/\/+$/, '')).concat(ogUrl) : router && "".concat(APP_URL.replace(/\/+$/, '')).concat(router && router.pathname !== '/' ? router.pathname : ''),
      property: "og:url"
    }), description && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        content: description.replace(/\s\s+/g, ' '),
        name: "description"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        content: description.replace(/\s\s+/g, ' '),
        property: "og:description"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        content: description.replace(/\s\s+/g, ' '),
        name: "twitter:description"
      })]
    }), noIndex ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
      content: "noindex, follow",
      name: "robots"
    }) : router && router.pathname !== '_error' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("link", {
      href: canonical ? "".concat(APP_URL.replace(/\/+$/, '')).concat(canonical) : router && "".concat(APP_URL.replace(/\/+$/, '')).concat(router.pathname !== '/' ? router.pathname : ''),
      rel: "canonical"
    }), router && ![_routes__WEBPACK_IMPORTED_MODULE_3__/* .routes.tlsTest */ ._j.tlsTest].includes(router.pathname) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        content: "".concat(title, " | CDN77.com"),
        property: "og:title"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        content: "".concat(title, " | CDN77.com"),
        name: "twitter:title"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        content: "summary",
        name: "twitter:card"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        content: imageOg !== null && imageOg !== void 0 ? imageOg : 'https://www.cdn77.com/open-graph.png',
        property: "og:image"
      }), imageOg && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        content: "1200",
        property: "og:image:width"
      }), imageOg && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        content: "628",
        property: "og:image:height"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        content: imageTwitter !== null && imageTwitter !== void 0 ? imageTwitter : 'https://www.cdn77.com/open-graph.png',
        name: "twitter:image"
      })]
    }), children]
  });
};

/***/ }),

/***/ 15535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ List; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/List/ListBullet/ListBullet.module.scss
var ListBullet_module = __webpack_require__(12868);
var ListBullet_module_default = /*#__PURE__*/__webpack_require__.n(ListBullet_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/List/ListBullet/ListBullet.tsx




var cx = bind_default().bind((ListBullet_module_default()));
var ListBullet = function ListBullet(_ref) {
  var size = _ref.size,
      type = _ref.type,
      color = _ref.color,
      shape = _ref.shape;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: cx(type, shape, color),
    style: {
      width: size === 'auto' ? '0.3em' : size,
      height: size === 'auto' ? '0.3em' : size
    }
  });
};
// EXTERNAL MODULE: ./src/components/Icon/Icon.tsx
var Icon = __webpack_require__(37078);
// EXTERNAL MODULE: ./src/components/Text/Text.tsx
var Text = __webpack_require__(40426);
// EXTERNAL MODULE: ./src/components/List/List.module.scss
var List_module = __webpack_require__(48543);
var List_module_default = /*#__PURE__*/__webpack_require__.n(List_module);
// EXTERNAL MODULE: ./src/components/Images/Icons/check.svg
var check = __webpack_require__(3303);
;// CONCATENATED MODULE: ./src/components/List/List.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var List_cx = bind_default().bind((List_module_default()));
var List = function List(_ref) {
  var _ref2;

  var _ref$type = _ref.type,
      Tag = _ref$type === void 0 ? 'ul' : _ref$type,
      _ref$bullet = _ref.bullet,
      bullet = _ref$bullet === void 0 ? {
    size: 'auto',
    shape: 'circle',
    type: 'filled',
    color: 'black'
  } : _ref$bullet,
      items = _ref.items,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'inherit' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'inherit' : _ref$color,
      _ref$opacity = _ref.opacity,
      opacity = _ref$opacity === void 0 ? 100 : _ref$opacity,
      align = _ref.align,
      _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? 20 : _ref$gap,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 24 : _ref$padding,
      _ref$line = _ref.line,
      line = _ref$line === void 0 ? 'none' : _ref$line,
      ulClassName = _ref.ulClassName,
      liClassName = _ref.liClassName;
  var finalBullet = react.useMemo(function () {
    if (Tag === 'ol') {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (List_module_default()).counter
      });
    }

    if (bullet === 'check') {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* Icon */.J, {
        color: "blue200",
        size: size === 'inherit' ? 12 : Math.floor(size * 0.75),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(check/* default */.Z, {})
      });
    }

    if ('type' in bullet && 'color' in bullet && 'shape' in bullet && 'size' in bullet) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ListBullet, _objectSpread({}, bullet));
    }

    return bullet;
  }, [Tag, bullet]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Tag, {
    className: List_cx('list', ulClassName, {
      withSeparator: line !== 'none' && items.length > 1
    }),
    style: (_ref2 = {}, (0,defineProperty/* default */.Z)(_ref2, '--padding', "".concat(padding, "px")), (0,defineProperty/* default */.Z)(_ref2, '--gap', "".concat(gap, "px")), (0,defineProperty/* default */.Z)(_ref2, '--line-offset', "".concat(Math.round(gap / 2), "px")), (0,defineProperty/* default */.Z)(_ref2, '--padding', "".concat(padding, "px")), _ref2),
    children: items.map(function (item, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: List_cx('item', liClassName, (0,defineProperty/* default */.Z)({
          withSeparator: line !== 'none' && index + 1 !== items.length
        }, "separator-".concat(line), line !== 'none')),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* Text */.x, {
          align: align,
          className: liClassName,
          color: color,
          opacity: opacity,
          size: size,
          tag: "div",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (List_module_default()).bulletWrapper,
            children: finalBullet
          }), item]
        })
      }, typeof item === 'string' ? item : index);
    })
  });
};

/***/ }),

/***/ 31686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useIsMounted; }
/* harmony export */ });
/* harmony import */ var _builds_purple_team_cdn77_frontend_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17674);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useIsMounted = function useIsMounted() {
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(false),
      _React$useState2 = (0,_builds_purple_team_cdn77_frontend_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_React$useState, 2),
      isMounted = _React$useState2[0],
      setIsMounted = _React$useState2[1];

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    setIsMounted(true);
  }, []);
  return isMounted;
};

/***/ }),

/***/ 20716:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(62890);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80607:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","inner":"AnimatedPath_inner__ZGu3L","overlay":"AnimatedPath_overlay__Rjhgf","path":"AnimatedPath_path__Cog4m","dash":"AnimatedPath_dash__yAwsx","squareWrapper":"AnimatedPath_squareWrapper__wokvT","square":"AnimatedPath_square__coJ78","pop":"AnimatedPath_pop__v_9ry","center":"AnimatedPath_center__toKff","dark":"AnimatedPath_dark__6lbs6","light":"AnimatedPath_light__GGaeN"};

/***/ }),

/***/ 61676:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","title":"CtaPanel_title__vfyTD","content":"CtaPanel_content__G8P1m","buttonsWrapper":"CtaPanel_buttonsWrapper__BKj4R","button":"CtaPanel_button__yWNke"};

/***/ }),

/***/ 19630:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","section":"CtaPanelWrapper_section__I_bFZ","background":"CtaPanelWrapper_background__jJEtB","linesBackground":"CtaPanelWrapper_linesBackground__G8nzf","content":"CtaPanelWrapper_content__2337f"};

/***/ }),

/***/ 48543:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","list":"List_list__M0n5r","withSeparator":"List_withSeparator__MGrAD","item":"List_item__LcNFs","separator-light":"List_separator-light__PC4el","bulletWrapper":"List_bulletWrapper__2fkWE","counter":"List_counter__0Ne7o"};

/***/ }),

/***/ 12868:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"ListBullet_black__OWTRX","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","circle":"ListBullet_circle__sZqNP","square":"ListBullet_square__k1nCb","bordered":"ListBullet_bordered__BCHFX","inherit":"ListBullet_inherit__U3EPw","blue":"ListBullet_blue__YwsY_","yellow":"ListBullet_yellow__z1IBu","filled":"ListBullet_filled__BfC40"};

/***/ }),

/***/ 80363:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","wrapper":"CoreFeatureItem_wrapper__0SrUV","content":"CoreFeatureItem_content__LBGP6","refWrapper":"CoreFeatureItem_refWrapper__8Sprl","image":"CoreFeatureItem_image__Mwy9A"};

/***/ }),

/***/ 91412:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","wrapper":"CoreFeatures_wrapper__IPuN8","content":"CoreFeatures_content__7mWyW","sticky":"CoreFeatures_sticky___d7Zs"};

/***/ }),

/***/ 27586:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","wrapper":"HomeHeader_wrapper__fya3U","container":"HomeHeader_container__RPGbt","titleWrapper":"HomeHeader_titleWrapper__TChnu","globe":"HomeHeader_globe__oghtP"};

/***/ }),

/***/ 7378:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","item":"HomeTiles_item__eI04w","icon":"HomeTiles_icon__XpNqb"};

/***/ }),

/***/ 57865:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","wrapper":"ContinentStats_wrapper__uK4j4","stats":"ContinentStats_stats__lo2JP","item":"ContinentStats_item__uMTsS","value":"ContinentStats_value__auxbP","name":"ContinentStats_name__sMrwX"};

/***/ }),

/***/ 87870:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","wrapper":"NetworkStats_wrapper__HDNMl","tilesWrapper":"NetworkStats_tilesWrapper__lfvSH","path":"NetworkStats_path__BDc88","tiles":"NetworkStats_tiles__JZC0x","item":"NetworkStats_item__E0ugO","itemContent":"NetworkStats_itemContent__4G38G","title":"NetworkStats_title__9G7KY","value":"NetworkStats_value__chv7C","mapTitle":"NetworkStats_mapTitle__zFJdr"};

/***/ }),

/***/ 35278:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","wrapper":"Tiles_wrapper__3XQ8L","higherContrast":"Tiles_higherContrast__e0cXx","item":"Tiles_item__a1A4S","layout-2-columns":"Tiles_layout-2-columns__22b_G","layout-3-columns":"Tiles_layout-3-columns__78MA0"};

/***/ }),

/***/ 39582:
/***/ (function(module) {

module.exports = {
        srcSet: "/_next/static/images/cta-globe-640.871c58ec.webp"+" 640w"+","+"/_next/static/images/cta-globe-828.96761849.webp"+" 828w"+","+"/_next/static/images/cta-globe-1080.3b4d7404.webp"+" 1080w"+","+"/_next/static/images/cta-globe-1138.b02e952a.webp"+" 1138w",
        images: [{path: "/_next/static/images/cta-globe-640.871c58ec.webp",width: 640,height: 640},{path: "/_next/static/images/cta-globe-828.96761849.webp",width: 828,height: 828},{path: "/_next/static/images/cta-globe-1080.3b4d7404.webp",width: 1080,height: 1080},{path: "/_next/static/images/cta-globe-1138.b02e952a.webp",width: 1138,height: 1138}],
        src: "/_next/static/images/cta-globe-1138.b02e952a.webp",
        toString: function(){return "/_next/static/images/cta-globe-1138.b02e952a.webp"},
        
        width: 1138,
        height: 1138
      }

/***/ }),

/***/ 75889:
/***/ (function(module) {

module.exports = {
        srcSet: "/_next/static/images/client-centric-640.645ce7fc.webp"+" 640w"+","+"/_next/static/images/client-centric-828.c6932523.webp"+" 828w"+","+"/_next/static/images/client-centric-950.a32194b6.webp"+" 950w",
        images: [{path: "/_next/static/images/client-centric-640.645ce7fc.webp",width: 640,height: 744},{path: "/_next/static/images/client-centric-828.c6932523.webp",width: 828,height: 963},{path: "/_next/static/images/client-centric-950.a32194b6.webp",width: 950,height: 1105}],
        src: "/_next/static/images/client-centric-950.a32194b6.webp",
        toString: function(){return "/_next/static/images/client-centric-950.a32194b6.webp"},
        
        width: 950,
        height: 1105
      }

/***/ }),

/***/ 9298:
/***/ (function(module) {

module.exports = {
        srcSet: "/_next/static/images/stability-640.52fefce7.webp"+" 640w"+","+"/_next/static/images/stability-828.72b42b27.webp"+" 828w"+","+"/_next/static/images/stability-950.afb3f932.webp"+" 950w",
        images: [{path: "/_next/static/images/stability-640.52fefce7.webp",width: 640,height: 763},{path: "/_next/static/images/stability-828.72b42b27.webp",width: 828,height: 987},{path: "/_next/static/images/stability-950.afb3f932.webp",width: 950,height: 1132}],
        src: "/_next/static/images/stability-950.afb3f932.webp",
        toString: function(){return "/_next/static/images/stability-950.afb3f932.webp"},
        
        width: 950,
        height: 1132
      }

/***/ }),

/***/ 89948:
/***/ (function(module) {

module.exports = {
        srcSet: "/_next/static/images/video-delivery-640.ced218f8.webp"+" 640w"+","+"/_next/static/images/video-delivery-828.c4cb3a68.webp"+" 828w"+","+"/_next/static/images/video-delivery-958.97c02694.webp"+" 958w",
        images: [{path: "/_next/static/images/video-delivery-640.ced218f8.webp",width: 640,height: 749},{path: "/_next/static/images/video-delivery-828.c4cb3a68.webp",width: 828,height: 969},{path: "/_next/static/images/video-delivery-958.97c02694.webp",width: 958,height: 1121}],
        src: "/_next/static/images/video-delivery-958.97c02694.webp",
        toString: function(){return "/_next/static/images/video-delivery-958.97c02694.webp"},
        
        width: 958,
        height: 1121
      }

/***/ }),

/***/ 56129:
/***/ (function(module) {

module.exports = {
        srcSet: "/_next/static/images/globe-640.6480d0af.webp"+" 640w"+","+"/_next/static/images/globe-828.3a1e4523.webp"+" 828w"+","+"/_next/static/images/globe-1080.cb3ac972.webp"+" 1080w"+","+"/_next/static/images/globe-1200.55079013.webp"+" 1200w"+","+"/_next/static/images/globe-1913.c0a34a03.webp"+" 1913w",
        images: [{path: "/_next/static/images/globe-640.6480d0af.webp",width: 640,height: 681},{path: "/_next/static/images/globe-828.3a1e4523.webp",width: 828,height: 881},{path: "/_next/static/images/globe-1080.cb3ac972.webp",width: 1080,height: 1149},{path: "/_next/static/images/globe-1200.55079013.webp",width: 1200,height: 1277},{path: "/_next/static/images/globe-1913.c0a34a03.webp",width: 1913,height: 2035}],
        src: "/_next/static/images/globe-1913.c0a34a03.webp",
        toString: function(){return "/_next/static/images/globe-1913.c0a34a03.webp"},
        
        width: 1913,
        height: 2035
      }

/***/ }),

/***/ 66313:
/***/ (function(module) {

module.exports = {
        srcSet: "/_next/static/images/map-640.ca75a6f7.webp"+" 640w"+","+"/_next/static/images/map-828.8228e0ea.webp"+" 828w"+","+"/_next/static/images/map-1080.4ea0ab3b.webp"+" 1080w"+","+"/_next/static/images/map-1200.ca9379b1.webp"+" 1200w"+","+"/_next/static/images/map-1920.981654d3.webp"+" 1920w"+","+"/_next/static/images/map-2048.7743b421.webp"+" 2048w"+","+"/_next/static/images/map-3187.112e7f12.webp"+" 3187w",
        images: [{path: "/_next/static/images/map-640.ca75a6f7.webp",width: 640,height: 330},{path: "/_next/static/images/map-828.8228e0ea.webp",width: 828,height: 427},{path: "/_next/static/images/map-1080.4ea0ab3b.webp",width: 1080,height: 556},{path: "/_next/static/images/map-1200.ca9379b1.webp",width: 1200,height: 618},{path: "/_next/static/images/map-1920.981654d3.webp",width: 1920,height: 989},{path: "/_next/static/images/map-2048.7743b421.webp",width: 2048,height: 1055},{path: "/_next/static/images/map-3187.112e7f12.webp",width: 3187,height: 1642}],
        src: "/_next/static/images/map-3187.112e7f12.webp",
        toString: function(){return "/_next/static/images/map-3187.112e7f12.webp"},
        
        width: 3187,
        height: 1642
      }

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5881,8439,9339,764,9517,9774,2888,179], function() { return __webpack_exec__(20716); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);